import API from './index';
import cruxProxy from './cruxProxy';
import methods from '../constants/methods';

const AGGREGATE_SEARCH_PATH = '/api/batch/aggregate-search';

/**
 * Calls the aggregate search endpoint to fetch dynamic filter options.
 * @param {Object} requestBody - The aggregate search request body
 * @param {Array} requestBody.requests - Array of request objects with filters and aggregations
 * @returns {Promise<Object>} - The aggregate search response
 */
const fetchAggregateSearch = (requestBody) => {
    const requestOptions = {
        path: AGGREGATE_SEARCH_PATH,
        isProxy: true,
        timeout: API.getTimeouts().large,
    };

    const headerOptions = {
        method: methods.POST.method,
        headers: {
            'Content-Type': 'application/json',
            ...cruxProxy.getXsrfHeader(),
        },
        body: requestBody,
    };

    return API.initiateSessionApiCall(requestOptions, headerOptions);
};

export default {
    fetchAggregateSearch,
};
